import { type CreateUIAnalyticsEvent } from '@atlaskit/analytics-next';

import ConfluenceSlackService from './ConfluenceSlackService';
import JiraSlackService from './JiraSlackService';
import PlatformSlackService from './PlatformSlackService';
import { type SlackService } from './SlackService';
import { type AtlassianSlackProduct } from './types';

export function slackServiceFactory(
	cloudId: string,
	product: AtlassianSlackProduct,
	createAnalyticsEvent: CreateUIAnalyticsEvent,
): SlackService {
	switch (product) {
		case 'platform':
			return new PlatformSlackService(cloudId, createAnalyticsEvent);
		case 'confluence':
			return new ConfluenceSlackService(cloudId, createAnalyticsEvent);
		default:
			return new JiraSlackService(cloudId, createAnalyticsEvent);
	}
}
